import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BookingHistoryRoutingModule } from './booking-history.routing.module';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ShareModule } from '../share.module';
import { TooltipModule } from 'ng2-tooltip-directive';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { NgSelectModule } from '@ng-select/ng-select';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  imports: [
    CommonModule,
    BookingHistoryRoutingModule,
    NgbModule,
    ShareModule,
    FormsModule,
    ReactiveFormsModule,
    TooltipModule,
    NgxSmartModalModule,
    NgSelectModule,
    BsDatepickerModule,
    
  ],
  declarations: [],
})
export class BookingHistoryModule {

}